module.exports = __webpack_public_path__ + "static/media/wind-mill-purple.c50ef9e4.svg";